
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.907 24a.75.75 0 010-1.5h6.75v-1.547a7.437 7.437 0 01-4.226-2.054A7.191 7.191 0 016.816 16.5H5.09a.75.75 0 010-1.5h5.25a.75.75 0 010 1.5H8.476c.269.491.609.942 1.002 1.326a5.9 5.9 0 003.882 1.677.65.65 0 01.159.007l.075.001a5.875 5.875 0 004.48-2.073 5.582 5.582 0 001.314-4.094 5.603 5.603 0 00-1.474-3.352l-1.557 1.531a1.691 1.691 0 01-2.37-.004l-1.327-1.301a1.661 1.661 0 01-.026-2.345l4.002-3.935a1.693 1.693 0 011.189-.482c.425 0 .825.153 1.136.432l1.634-1.635-.97-.97c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53.331-.223.531-.223.389.078.53.22l3 3c.142.141.22.33.22.53s-.078.389-.22.53a.749.749 0 01-1.06 0l-.969-.969-1.623 1.624.305.3a1.653 1.653 0 01.026 2.345l-1.382 1.359a7.096 7.096 0 011.899 4.281 7.065 7.065 0 01-2.125 5.679 7.4 7.4 0 01-4.602 2.093V22.5h6a.75.75 0 01.001 1.5H5.907zM17.826 4.951a.198.198 0 00-.139.055l-3.975 3.908a.175.175 0 00-.048.119c0 .03.008.073.047.11l1.326 1.301a.195.195 0 00.277-.001l3.975-3.908a.155.155 0 00.049-.117.154.154 0 00-.048-.112l-1.327-1.301a.196.196 0 00-.137-.054zM.751 8.865A.751.751 0 01.225 7.58l2.618-2.571a1.695 1.695 0 012.376-.001L6.473 6.24a.196.196 0 00.137.055.201.201 0 00.14-.058L11.572 1.5h-1.166a.75.75 0 11.001-1.5h3l.033.001a.742.742 0 01.238.05l.018.007a.737.737 0 01.415.442.734.734 0 01.044.25v3a.75.75 0 01-1.5 0V2.538L7.798 7.309a1.693 1.693 0 01-2.374.003L4.169 6.079a.197.197 0 00-.137-.057.2.2 0 00-.139.058L1.276 8.65a.744.744 0 01-.525.215z"}})])
          )
        }
      }
    